import React, { useEffect, useState } from 'react'
import SideBar from '../../Layouts/SideBar'
import { useParams } from 'react-router-dom'
import Instance from '../../Services/Instance'
import config from "../../Services/config"

function ShowPost() {
  const [post, setPost] = useState(null) // null au lieu d'un objet vide
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const { id } = useParams()

  const fetchData = async () => {
      try {
          setLoading(true)
          // Correction de l'URL : faq/categories au lieu de post
          const result = await Instance.get(`${config.api_url}/faq/categories/${id}`)
          setPost(result.data.data) // result.data.data pour correspondre à votre backend
          setLoading(false)
      } catch (error) {
          console.log("Erreur lors de la récupération de cette catégorie", error)
          setError(error)
          setLoading(false)
      }
  }

  useEffect(() => {
      fetchData()
  }, [id])
  
  if (loading) {
      return (
          <div>
              <SideBar />
              <div className='show-elements-details'>
                  <p>Chargement...</p>
              </div>
          </div>
      )
  }

  if (error || !post) {
      return (
          <div>
              <SideBar />
              <div className='show-elements-details'>
                  <p>Catégorie non trouvée ou erreur lors du chargement</p>
              </div>
          </div>
      )
  }

  return (
    <div>
      <SideBar />
      <div className='show-elements-details'>
                <p>Nom : <span> {post.name} </span></p>
                <p>Slug : <span> {post.slug} </span></p>
                <p>Description : <span> {post.description || 'Aucune description'} </span></p>
                <p>Ordre : <span> {post.order} </span></p>
                <p>Statut : <span> {post.isActive ? 'Active' : 'Inactive'} </span></p>
                <p>Créé le : <span> {new Date(post.createdAt).toLocaleDateString('fr-FR')} </span></p>
            </div>
    </div>
  )
}

export default ShowPost